import { render, staticRenderFns } from "./notification-button.vue?vue&type=template&id=9e289646"
import script from "./notification-button.vue?vue&type=script&lang=js"
export * from "./notification-button.vue?vue&type=script&lang=js"
import style0 from "./notification-button.vue?vue&type=style&index=0&id=9e289646&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./notification-button.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports